export default "__VITE_ASSET__96dWEdPI__"